import React, { useState, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import { useAPI } from '../../api';
import { useOrgContext } from 'components/OrgContextProvider';

import WorkspacesListContainer from './WorkspacesListContainer';
import WorkspaceCreateNewContainer from './WorkspaceCreateNewContainer';
import WorkspaceContainer from './WorkspaceContainer';
import { WorkspaceInfo } from 'types';

const WorkspacesContainer = () => {
	const api = useAPI();
	const ctx = useOrgContext();
	const tenantID = ctx?.tenantID;

	const [workspaces, setWorkspaces] = useState<WorkspaceInfo[]>([]);

	const loadWorkspaces = () => {
		if (!tenantID) {
			setWorkspaces([]);
			return;
		}
		api.get<WorkspaceInfo[]>(`/api/t/${tenantID}/workspaces`)
		.then(ws => setWorkspaces(ws.map(w => ({ ...w, tenantID }))))
		.catch(() => setWorkspaces([]));
	};

	useEffect(() => {
		loadWorkspaces();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tenantID]);

	return !tenantID ? <p>Select a tenant to view workspaces.</p> : (
		<Routes>
			<Route path="/" element={<WorkspacesListContainer workspaces={workspaces} onChanged={loadWorkspaces} />} />
			<Route path="/new" element={<WorkspaceCreateNewContainer onChanged={loadWorkspaces} />} />
			<Route path="/:workspaceID/*" element={<WorkspaceContainer />} />
		</Routes>
	);
};

export default WorkspacesContainer;
